import LayautContext from 'Context/ContextLayaut';
import { useContext } from 'react';

const ServiciosCalificacion = () => {
    const context = useContext(LayautContext);
    return {
        getTrainerCursosInt: context.llamarServidor('Trainer/getTrainerCursosInt'),
        getTrainerCursosPuesto: context.llamarServidor('Trainer/getTrainerCursosPuesto'),
        getTrainerCalificacion: context.llamarServidor('Trainer/getTrainerCalificacion'),
        getExamen: context.llamarServidor('Trainer/getExamen'),
        getExamenHistorial: context.llamarServidor('Trainer/getExamenHistorial'),
        restaurarExamen: context.llamarServidorRespuesta('Trainer/restaurarExamen'),
        editarCalificacion: context.llamarServidorRespuesta('Trainer/editarCalificacion'),
        guardarCalificacionEvidencia: context.llamarServidorRespuesta('Trainer/calificarEvidencia'),
        getDetalleUltimoIntentoExamen: context.llamarServidor('HomeVentas/getDetalleUltimoIntentoExamen'),
        // servicios maetrial entregado
        getRespuestaActividad: context.llamarServidor('HomeVentas/getRespuestaActividad/'),
        getCursosActivos: context.llamarServidor('Curso/getCursosActivos'),
        getGruposPorCurso: context.llamarServidor('Trainer/getGruposPorCurso'),
        getMaterialEvidencia: context.llamarServidor('Trainer/getMaterialEvidencia'),
        getUrlDescargaEvidencia: context.llamarServidor('Trainer/getUrlDescargaEvidencia'),
        getEvidenciaColaborador: context.llamarServidor('Trainer/getEvidenciaColaborador')
    };
};

export default ServiciosCalificacion;
